import styled, { css } from 'styled-components';

import Pagination from 'Components/Pagination';

export const List = styled.ul`
    list-style: none;
    padding: 0;
    margin: 0;
`;

export const Item = styled.li`
    ${({ theme }) => css`
        display: block;

        &:not(:last-child) {
            padding-bottom: 1.5rem;

            @media ${theme.breakpoints.xlarge.media} {
                padding-bottom: 0.625rem;
            }
        }
    `}
`;

export const NoResults = styled.div`
    text-align: center;
    font-weight: 600;
    padding: 2rem 0 10rem;
    font-size: 1.25rem;

    @media ${({ theme }) => theme.breakpoints.large.media} {
        font-size: 1.5rem;
        padding: 2rem 0 15rem;
    }
`;

export const PaginationWrapper = styled.div`
    ${({ theme }) => css`
        padding: 2rem 0;
        text-align: center;

        @media ${theme.breakpoints.medium.media} {
            padding: 3rem 0;
        }
    `}
`;

export const StyledPagination = styled(Pagination)`
    ${({ theme }) => css`
        background: ${theme.colors.primaryContrast.hex};
    `}
`;
